import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import socket from "socket.io-client";
import { ChatConversation } from "./App";
import cookie from "react-cookies";
import { Redirect } from "react-router";

let LOGOUT_FLAG = false;

const Sockt = ({ serverUrl, id, newMessage }) => {
  const { handelChat } = useContext(ChatConversation);
  const [isConnected, setConnected] = React.useState(false);
  const [flagCall, setFlagCall] = React.useState(true);

  let test = 0;
  const client = socket.connect(serverUrl, {
    query: {
      id: id,
    },
  });

  useEffect(() => {
    client.on(newMessage, (data) => {
      console.log("Socket take place NewMessage", data);
      let message = {
        message: {
          text: data.message.message.text ? data.message.message.text : null,
          image: data.message.message.image
            ? `${data.message.message.image}`
            : null,
        },
        sender: data.message.sender,
        receiver: data.message.receiver,
        id: data.message.id,
        createdAt: data.message.createdAt,
      };
      handelChat(message);
    });
  }, []);
  useEffect(() => {
    client.on("connect", () => setConnected(true));
    // console.log("client take place==> ",client)
  }, []);
  // if (flagCall) {
  //     setFlagCall(false)

  // }
  // console.log("flag logout from socket io==> ")
  return <div></div>;
};

Sockt.propTypes = {
  serverUrl: PropTypes.string.isRequired,
  topic: PropTypes.string.isRequired,
};

export default Sockt;
